<style lang="less" scoped>
@import '../../../style/common/variable';
.contentbox {display: flex;justify-content: space-between;align-items: center;margin-bottom: 19px;flex-wrap: wrap;margin: 0;padding: 0;list-style: none;width: 100%;
  .content:nth-of-type(-n+3) {margin-bottom: 17px;}
  .content:hover {
    .ptop:hover {color: #13569e;}
  }
  .content {width: 235px;height: 257px;background-color: #eeeeee;border-radius: 2px;cursor: pointer;
    .libox {width: 235px;height: 257px;
      img {width: 235px;height: 125px;background-color: #00afff;border-radius: 2px;}
      p {width: 212px;font-family: AlibabaPuHuiTi-Regular;font-size: 16px;font-stretch: normal;line-height: 20px;letter-spacing: 0px;color: #08032b;margin: 8px auto;
        span {display: inline-block;text-align: left;height: 80px;width: 100%;}
        .ptop {font-family: AlibabaPuHuiTi-Regular;font-size: 16px;font-stretch: normal;line-height: 20px;letter-spacing: 0px;color: #08032b;}
        .pbottom {height: 20px;	font-family: AlibabaPuHuiTi-Regular;font-size: 10px;font-stretch: normal;line-height: 14px;letter-spacing: 1px;color: #666666;margin-top: 10px;margin-bottom: 10px;text-align: right;}
      }
    }
  }
}
@media screen and (max-width: @max-screen){
    .contentbox{display: flex;flex-wrap: wrap;justify-content: space-around;align-items: center;width: 100vw;height: 8.3rem;
      .content{margin-bottom: 0 !important;}
      li{width: 40vw !important;margin-top: 0;margin-right: 0; height: 2.7rem !important;
        span{margin: 0;}
      }
      .libox{width: 40vw !important; height: 1.3rem !important;
        img{width: 40vw !important; height: 1.3rem !important;}
        p{width: 40vw !important; display: flex; flex-direction: column;
          span{font-size: .14rem !important;}
          .ptop{width: 34vw !important;height: .95rem !important; margin-left: 3vw;}
        }
      }
    }
}
</style>

<!-- 安进 2021.6.30 资讯动态组件-->
<template>
  <ul class="contentbox">
    <li class="content" v-for="(item, index) in Information" :key="index" @click="handleClick(item)">
      <div class="libox" v-if="index<6">
        <img :src="item.thumb" />
        <p>
          <span class="ptop">{{ item.title }}</span>
          <span class="pbottom">{{ (item.time * 1000) | formatDate() }}</span>
        </p>
      </div>
    </li>
  </ul>
</template>

<script>
import filters from '../method/filter.js'
export default {
  props: ['Information'],
  mixins: [filters],
  data()
  {
    return {
      information: []//资讯动态
    }
  },
  methods: {
    // 点击 图片或标题， 将整个对象传递给父组件
    handleClick(item)
    {
      this.$emit('handleClick', item)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/plugins/app/assembly/Information.vue